import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import * as bootbox from "bootbox";
import Ajax from "DMS/Seed/Seed.Ajax";
import Tab from "DMS/Seed/Seed.Tab";
import { resizeScreen } from "DMS/Utils/resizeScreen";
class Interface {
    Init(pNomliste) {
        var pTarget = Tab.GetFrame();
        $(pTarget).css('min-width', '1100px');
        $(pTarget).removeClass('resizable');
        resizeScreen();
        // General
        $('.draggable-item').mouseenter(function () {
            $('.draggable-item.selected-item').removeClass('selected-item');
            $('.draggable-item[name=' + $(this).attr('name') + ']').addClass('selected-item');
        });
        $('.draggable-item').mouseleave(function () {
            $('.draggable-item.selected-item').removeClass('selected-item');
        });
        // Draggable
        $('.champ-item.source-item').draggable({
            connectToSortable: '.champ-sortable',
            helper: 'clone',
            delay: 0,
            distance: 20,
            containment: 'document'
        });
        $('.bouton-item.source-item').draggable({
            connectToSortable: '.bouton-sortable',
            helper: 'clone',
            delay: 0,
            distance: 20,
            containment: 'document'
        });
        // Droppable
        $('.TrashZoneInterface').droppable({
            accept: '.sorted-item',
            tolerance: 'pointer',
            /*hoverClass: 'ui-state-active',*/
            drop: function (event, ui) {
                $(this).css('background-color', 'white');
                var parentClass = $('.ui-sortable-helper').parent()
                    .attr('class');
                var findMe = 'section-sortable';
                if (parentClass.indexOf(findMe) > -1) {
                    bootbox.alert("Suppression d'une section impossible");
                }
                else {
                    ui.draggable.remove();
                }
            },
            over: function (event, ui) {
                $(this).css('background-color', 'lightgreen');
            },
            out: function (event, ui) {
                $(this).css('background-color', 'white');
            }
        });
        $('.recherche-sortable').droppable({
            tolerance: 'pointer',
            hoverClass: 'ui-state-active',
            drop: function (event, ui) {
                ui.draggable.removeClass('source-item');
                ui.draggable.addClass('sorted-item');
            }
        });
        $('.liste-sortable').droppable({
            accept: '.champ-item',
            tolerance: 'pointer',
            hoverClass: 'ui-state-active',
            drop: function (event, ui) {
                ui.draggable.removeClass('source-item');
                ui.draggable.addClass('sorted-item');
            }
        });
        // Sortable
        $('.recherche-sortable').sortable({
            placeholder: 'draggable-item-placeholder',
            tolerance: 'pointer',
            opacity: 0.8,
            cursor: 'move',
            update: function (event, ui) {
                var pos = '';
                var cur = 1;
                $(this).find('.draggable-item').each(function (i) {
                    pos += '&' + $(this).attr('name') + '=' + cur;
                    cur++;
                });
                Ajax.Post({
                    url: '_module/Interface/UpdateRecherche.php',
                    data: pos
                        + '&nomliste=' + pNomliste,
                    json: true,
                    async: true
                });
            }
        });
        $('.liste-sortable').sortable({
            placeholder: 'draggable-item-placeholder',
            tolerance: 'pointer',
            opacity: 0.8,
            cursor: 'move',
            update: function (event, ui) {
                var pos = '';
                var cur = 1;
                $(this).find('.draggable-item').each(function (i) {
                    pos += '&' + $(this).attr('name') + '=' + cur;
                    cur++;
                });
                Ajax.Post({
                    url: '_module/Interface/UpdateListe.php',
                    data: pos
                        + '&nomliste=' + pNomliste,
                    json: true,
                    async: true
                });
            }
        });
        $('.section-sortable').sortable({
            placeholder: 'draggable-item-placeholder',
            tolerance: 'pointer',
            opacity: 0.8,
            cursor: 'move',
            update: function (event, ui) {
                var pos = '';
                var cur = 0;
                $(this).find('.draggable-item').each(function (i) {
                    pos += '&' + $(this).attr('name') + '=' + cur;
                    cur++;
                });
                Ajax.Post({
                    url: '_module/Interface/UpdateSection.php',
                    data: pos
                        + '&nomliste=' + pNomliste,
                    json: true,
                    async: true
                });
            }
        });
        $('.section-bouton-sortable').sortable({
            placeholder: 'draggable-item-placeholder',
            tolerance: 'pointer',
            opacity: 0.8,
            cursor: 'move',
            connectWith: '.section-bouton-sortable',
            update: function (event, ui) {
                var pos = '';
                var cur = 1;
                $(this).find('.draggable-item').each(function (i) {
                    pos += '&' + $(this).attr('name') + '=' + cur;
                    cur++;
                });
                Ajax.Post({
                    url: '_module/Interface/UpdateButton.php',
                    data: pos
                        + '&nomliste=' + pNomliste
                        + '&sortableID=' + $(this).attr('id'),
                    json: true,
                    async: true
                });
            }
        });
        $('.section-champ-sortable').sortable({
            placeholder: 'draggable-item-placeholder',
            tolerance: 'pointer',
            opacity: 0.8,
            cursor: 'move',
            connectWith: '.section-champ-sortable',
            update: function (event, ui) {
                var pos = '';
                var cur = 1;
                $(this).find('.draggable-item').each(function (i) {
                    pos += '&' + $(this).attr('name') + '=' + cur;
                    cur++;
                });
                Ajax.Post({
                    url: '_module/Interface/UpdateFormulaire.php',
                    data: pos + '&nomliste=' + pNomliste + '&sortableID=' + $(this).attr('id'),
                    json: true,
                    async: true
                });
            }
        });
    }
}
export default new Interface();
//# sourceMappingURL=Seed.Interface.js.map